import ChatMessageContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/ChatMessageContent";
import TextContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/TextContent";

export default class ChatMessage {
    /**
     * @constructor
     * @param {ChatMessageContent} content 
     * @param {boolean} fromPlayer 
     * @param {number} time 
     * @param {string} npcId 
     * @param {boolean} isRead 
     */
    constructor(content, fromPlayer, time, npcId = null, isRead = false) {
        this._content = content;
        this._fromPlayer = fromPlayer;
        this._time = time;
        this._npcId = npcId;
        this._isRead = isRead;
    }

    get content() {
        return this._content;
    }

    get npcId() {
        return this._npcId;
    }

    get fromPlayer() {
        return this._fromPlayer;
    }

    get time() {
        return this._time;
    }

    get isRead() {
        return this._isRead;
    }

    markAsRead() {
        this._isRead = true;
    }

    toObject() {
        return {
            content: this._content.convertToObject(),
            fromPlayer: this._fromPlayer,
            time: this._time,
            npcId: this._npcId,
            isRead: this._isRead
        };
    }

    fromObject(obj, languagePack) {
        this._content = textContentObject(obj.content, languagePack);
        this._fromPlayer = obj.fromPlayer;
        this._time = obj.time;
        this._npcId = obj.npcId;
        this._isRead = obj.isRead;
        return this;
    }
}

const textContentObject = function (obj, languagePack) {
    const textContent = new TextContent(languagePack, null, null, null, null, null, null);
    textContent.setPropertiesFromObject(obj);
    return textContent;
}